import React from 'react'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import * as Styled from './styled'

class Switch extends React.Component {
    constructor(props) {
        super(props)
        this.handleChange = this.handleChange.bind(this)
    }

    handleChange(e) {
        this.props.onChange('grade', e.target.checked)
    }

    render() {
        let displayStyle = this.props.state.checked ? "btn-success" : "btn-danger"
        return (
            <Styled.Label>
                <Styled.SwitchWrapper className={'default'}>
                    <input
                        type="checkbox"
                        checked={this.props.state.checked}
                        disabled={this.props.loading}
                        onChange={(e) => this.handleChange(e)}
                    />
                    <span className={`${displayStyle} switch`}>
                        <span className="switch-handle" />
                    </span>
                </Styled.SwitchWrapper>
                <Styled.SwitchLabel className="sm-font-size">{this.props.state.text}</Styled.SwitchLabel>
            </Styled.Label>
        )
    }
}

Switch.propTypes = {
    onChange: PropTypes.func,
    state: PropTypes.oneOfType([
        PropTypes.obj,
        PropTypes.any,
    ]),
    loading: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.any,
    ]),
}

export default withTranslation()(Switch)


// WEBPACK FOOTER //
// ./src/components/UI/Switch.jsx